import { render, staticRenderFns } from "./ClaimReport.vue?vue&type=template&id=908aef9c"
import script from "./ClaimReport.vue?vue&type=script&lang=js"
export * from "./ClaimReport.vue?vue&type=script&lang=js"
import style0 from "./ClaimReport.vue?vue&type=style&index=0&id=908aef9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports